module.exports = __webpack_public_path__ + "15_vast.pdf?45174f67c2cfae58c196e5727746bba3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperData/15_vast.pdf
// module id = 148
// module chunks = 0